$(document).ready(function() {
      if($("body").hasClass("template-product-gift-card")){
            $('.template-product-gift-card fieldset .form__label__value, fieldset label span').each(function(){
            var amountText = $(this).text().trim();
            var amount = parseFloat(amountText.replace(/[^0-9.-]+/g, ''));
            if (!isNaN(amount)) {
            var formattedAmount = '₹' + amount.toLocaleString();
            $(this).text(formattedAmount);
            }
            });
            
            $('.variations label').on('click', function() {
            var denomination_price = $(this).find("span").text(); 
            setTimeout(function() {
            $(".gift-card-selected-var").text(denomination_price);
            }, 300);
            });
               
            const intervalId = setInterval(() => {
            const popupBackdrop = document.querySelector('.Rise-popup-backdrop');
            if (popupBackdrop && popupBackdrop.classList.contains('show')) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
            }));
            } 
            }, 100);
      }
 document.addEventListener("product:variant-change", function (evt) {
  const newVariant = event.detail.variant;

  if (newVariant && typeof newVariant.inventory_quantity !== 'undefined') {
    const newQty = newVariant.inventory_quantity;

    // Find the span inside the cstm-inventory-content and update it
    const qtySpan = document.querySelector('.cstm-inventory-content .inventory_quantity');

    if (qtySpan) {
      qtySpan.textContent = newQty;
    } else {
      console.warn('inventory_quantity span not found.');
    }
  } else {
    console.warn('No inventory_quantity on variant.');
  }
setTimeout(() => {
  const getThreshold = document.querySelector(".product-inventory-notice--bar-new.new-threshold");

  if (getThreshold) {

    getThreshold.classList.add("new-threshold-bar");
    console.log(getThreshold);

    const getAttribute = getThreshold.getAttribute("threshold"); 
    console.log("Original attribute:", getAttribute);

    if (getAttribute) {

      let numberValue = parseFloat(getAttribute); 

      console.log("Extracted number:", numberValue);
      if(numberValue >500){
          numberValue = 500;
      }
      let percentValue = (numberValue / 500) * 100;
      const spanInside = getThreshold.querySelector("span");
      if (spanInside) {
        
        spanInside.style.setProperty('width', percentValue + "%", 'important');
      }
    }
  } else {
    console.warn("Element '.new-threshold' not found. load");
  }
}, 1400); 
});





const getThreshold = document.querySelector(".product-inventory-notice--bar-new.new-threshold");
if (getThreshold) {

    getThreshold.classList.add("new-threshold-bar-load");
    console.log(getThreshold);

    const getAttribute = getThreshold.getAttribute("threshold"); 
    console.log("Original attribute:", getAttribute);

    if (getAttribute) {

      let numberValue = parseFloat(getAttribute); 

      console.log("Extracted number:", numberValue);
        if(numberValue >500){
          numberValue = 500;
      }
      let percentValue = (numberValue / 500) * 100;
      const spanInside = getThreshold.querySelector("span");
      if (spanInside) {
        
        spanInside.style.setProperty('width', percentValue + "%", 'important');
      }
    }
  } else {
    console.warn("Element '.new-threshold' not found.");
  }
});



// document.addEventListener("product:variant-change", function (evt) {
//   console.log("Variant-change")
//     const variant = evt.detail.variant;
//     console.log("variant",variant);
//     if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
//         let featuredSrc = variant.featured_media.preview_image.src;

//         // Select the img inside the div with class 'product-single__media-image'
//         const imgEl = document.querySelector(".product-single__media-image img");

//         if (imgEl) {
//             imgEl.src = featuredSrc;
//             imgEl.srcset = featuredSrc;

//             console.log("Updated image src and srcset:", featuredSrc);
//         }
//     } else {
//         console.log("No featured media src found for this variant.");
//     }
// });




// document.addEventListener("product:variant-change", function (evt) {
//     const variant = evt.detail.variant;
//     if (
//         variant.featured_media &&
//         variant.featured_media.preview_image &&
//         variant.featured_media.preview_image.src
//     ) {
//         let featuredSrc = variant.featured_media.preview_image.src;
//         const imgEl = document.querySelector(".product-single__media-image img");

//         if (imgEl) {
//             const currentSrc = imgEl.src;
//             const newSrcAbsolute = new URL(featuredSrc, window.location.origin).href;
//             if (currentSrc === newSrcAbsolute) {
//                 return;
//             }
//             imgEl.src = featuredSrc;
//             imgEl.srcset = featuredSrc;
//         }
//     }
// });





// document.addEventListener("product:variant-change", function (evt) {
//     if (window.innerWidth < 1024) {
//         console.log("Skipping variant change logic on mobile/tablet");
//         return; 
//     }

//     console.log("Variant-change");
//     const variant = evt.detail.variant;

//     if (
//         variant.featured_media &&
//         variant.featured_media.preview_image &&
//         variant.featured_media.preview_image.src
//     ) {
//         let featuredSrc = variant.featured_media.preview_image.src;
//         const newSrcAbsolute = new URL(featuredSrc, window.location.origin).href;

//         const imgEl = document.querySelector(".product-single__media-image img");

//         if (imgEl) {
//             const currentSrc = imgEl.src;

//             if (currentSrc === newSrcAbsolute) {
//                 console.log("Image src already matches. No update needed.");
//             } else {
//                 imgEl.src = featuredSrc;
//                 imgEl.srcset = featuredSrc;
//                 console.log("Updated image src and srcset:", featuredSrc);
//             }
//         }

//         const normalizeShopifyImageUrl = (url) => {
//             return url
//                 .replace(/_[0-9]+x[0-9]+_crop_center/, '')
//                 .split('?')[0];
//         };

//         const all_cstm_elements = document.querySelectorAll('.product-images__slide.product-images__slide-image');
//         const elementsExceptFirst = Array.from(all_cstm_elements).slice(1);

//         elementsExceptFirst.forEach((element, index) => {
//             const img = element.querySelector('img');
//             if (!img) return;

//             const imgSrcAbsolute = new URL(img.src, window.location.origin).href;

//             const normalizedImgSrc = normalizeShopifyImageUrl(imgSrcAbsolute);
//             const normalizedNewSrc = normalizeShopifyImageUrl(newSrcAbsolute);

//             console.log("normalizedImgSrc:", normalizedImgSrc);
//             console.log("normalizedNewSrc:", normalizedNewSrc);

//             if (normalizedImgSrc === normalizedNewSrc) {
//                 console.log(`Removing element #${index + 1} because image src matches featured src.`);
//                 setTimeout(function () {
//                     element.remove();
//                 }, 500);
//             }
//         });

//     } else {
//         console.log("No featured media src found for this variant.");
//     }
// });


document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail.variant;
  if (
    variant.featured_media &&
    variant.featured_media.preview_image &&
    variant.featured_media.preview_image.src
  ) {
    const featuredSrc = variant.featured_media.preview_image.src;
    const imgEl = document.querySelector(".variant_image img");
    if (imgEl) {
      if (imgEl.src === featuredSrc) {
        console.log("Image src matches, no update needed.");
        return;
      } else {
        imgEl.src = featuredSrc;
        imgEl.srcset = `
          ${featuredSrc}_375x469_crop_center.webp 375w,
          ${featuredSrc}_640x800_crop_center.webp 640w,
          ${featuredSrc}_960x1200_crop_center.webp 960w
        `;
        console.log("Updated image src and srcset:", featuredSrc);
      }
    } else {
      console.log("No image element found inside .variant_image.");
    }
  } else {
    console.log("No featured media src found for this variant.");
  }
  

});

document.addEventListener("product:variant-change", function (evt) {
  setTimeout(function(){
     const variant = evt.detail.variant;
  if (
    variant.featured_media &&
    variant.featured_media.preview_image &&
    variant.featured_media.preview_image.src
  ) {
    const featuredSrcmobile = variant.featured_media.preview_image.src;
      const imgElmobile = document.querySelector(".Nav_variant_img img");
    console.log("imgElmobile",imgElmobile);
    if (imgElmobile) {
      if (imgElmobile.src === featuredSrcmobile) {
        console.log("Image src matches, no update needed. Mobile");
        return;
      } else {
        imgElmobile.src = featuredSrcmobile;
        imgElmobile.srcset = `
          ${featuredSrcmobile}_375x469_crop_center.webp 375w,
          ${featuredSrcmobile}_640x800_crop_center.webp 640w,
          ${featuredSrcmobile}_960x1200_crop_center.webp 960w
        `;
        console.log("Updated image src and srcset: Mobile", featuredSrcmobile);
      }
    } else {
      console.log("No image element found inside .variant_image. Mobile ");
    }
  } else {
    console.log("No featured media src found for this variant. Mobile");
  }

    },500)

          const flickityElementMainImg = document.querySelector('#Product-Slider');

      if (flickityElementMainImg && typeof Flickity !== 'undefined') {
        const flktyMainImg = Flickity.data(flickityElementMainImg);
          
        if (flktyMainImg) {
          flktyMainImg.reloadCells();
          flktyMainImg.resize();
          flktyMainImg.select(0);
        }
      }

});


// document.addEventListener('DOMContentLoaded', function() {
//   const not_change_imgs = Array.from(document.querySelectorAll('.product-images__slide:not(.variant_image)'));
//   not_change_imgs.forEach(img => {
//     console.log(img);
//   });
// });

// document.addEventListener('DOMContentLoaded', function() {
//   const variantSrcDiv = document.querySelector('.cstm-all-variant-src');
//   console.log("variantSrcDiv",variantSrcDiv);
//   const variantSrcText = variantSrcDiv ? variantSrcDiv.innerText : '';
//   const variantUrls = variantSrcText
//     .split('\n')
//     .map(line => line.trim())
//     .filter(line => line && !line.includes('No image'))
//     .map(line => line.split(' - ')[1]);
//    console.log("variantUrls",variantUrls);


//   const notChangeImgs = Array.from(document.querySelectorAll('.product-images__slide:not(.variant_image)'));
//   notChangeImgs.forEach(slide => {
//     const img = slide.querySelector('img');
//     console.log('img',img);
//     if (variantUrls.includes(img.src)) {
//       setTimeout(function(){
//       slide.style.display = 'none';
//       },1000)
//     }
//   });
// });

// document.addEventListener('DOMContentLoaded', function () {
//   // Run only on desktop (e.g. width >= 768px)
//   // if (window.innerWidth < 768) {
//   //   console.log('Skipping script on mobile');
//   //   return;
//   // }
//   // Extract unique image ID from filename (e.g. 5132c918-3d78-4273-a15b-c93070121c9b)
//   function extractImageId(url) {
//     try {
//       const cleanUrl = url.split('?')[0]; // remove query string
//       const parts = cleanUrl.split('/');
//       const filename = parts[parts.length - 1]; // get filename
//       const idMatch = filename.match(/_(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})_/);
//       return idMatch ? idMatch[1] : null;
//     } catch (e) {
//       return null;
//     }
//   }
//   // Get all variant image IDs
//   const variantSrcItems = document.querySelectorAll('.cstm-all-variant-src li[data-src]');
//   const variantImageIds = Array.from(variantSrcItems)
//     .map(li => extractImageId(li.getAttribute('data-src')))
//     .filter(id => id);

//   console.log("Variant image IDs:", variantImageIds);

//   // Find and remove slides with matching image IDs
//   const slides = document.querySelectorAll('.product-images__slide:not(.variant_image)');
//   slides.forEach(slide => {
//     const img = slide.querySelector('img');
//     if (img) {
//       const imgId = extractImageId(img.src);
//       console.log('Image ID:', imgId);
//       if (variantImageIds.includes(imgId)) {
//         console.log('Removing slide with image ID:', imgId);
//         slide.remove(); // uncomment to actually remove
//       }
//     }
//   });

//   const slidesMobiles = document.querySelectorAll('.product-thumbnail.product-images__slide-item--variant:not(.Nav_variant_img)');
//     slidesMobiles.forEach(slidesMobile => {
//     const imgMobile = slidesMobile.querySelector('img');
//     if (imgMobile) {
//       const imgIdMobile = extractImageId(imgMobile.src);
//       console.log('Image ID Mobile:', imgIdMobile);
//       if (variantImageIds.includes(imgIdMobile)) {
//         console.log('Removing slide with image ID Mobile:', imgIdMobile);
//         slidesMobile.parentNode.remove();
//       }
//     }
//   });

// });




document.addEventListener('DOMContentLoaded', function () {
  // Extract unique image ID from filename (e.g. 5132c918-3d78-4273-a15b-c93070121c9b)
  function extractImageId(url) {
    try {
      const cleanUrl = url.split('?')[0]; // remove query string
      const parts = cleanUrl.split('/');
      const filename = parts[parts.length - 1]; // get filename
      const idMatch = filename.match(/_(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})_/);
      return idMatch ? idMatch[1] : null;
    } catch (e) {
      return null;
    }
  }

  // Get all variant image IDs
  const variantSrcItems = document.querySelectorAll('.cstm-all-variant-src li[data-src]');
  const variantImageIds = Array.from(variantSrcItems)
    .map(li => extractImageId(li.getAttribute('data-src')))
    .filter(id => id);

  console.log("Variant image IDs:", variantImageIds);

  // Find and remove slides with matching image IDs (desktop)
  const slides = document.querySelectorAll('.product-images__slide:not(.variant_image)');
  slides.forEach(slide => {
    const img = slide.querySelector('img');
    if (img) {
      const imgId = extractImageId(img.src);

      if (variantImageIds.includes(imgId)) {

        slide.remove();
      }
    }
  });



       
      const flickityElementMainImg = document.querySelector('#Product-Slider');

      if (flickityElementMainImg && typeof Flickity !== 'undefined') {
        const flktyMainImg = Flickity.data(flickityElementMainImg);
          //  alert(1);
        if (flktyMainImg) {
          flktyMainImg.reloadCells();
          flktyMainImg.resize();
          flktyMainImg.select(0);
        }
      }
 




  // Find and remove slides with matching image IDs (mobile thumbnails)
  const slidesMobiles = document.querySelectorAll('.product-thumbnail.product-images__slide-item--variant:not(.Nav_variant_img)');
  slidesMobiles.forEach(slidesMobile => {
    const imgMobile = slidesMobile.querySelector('img');
    if (imgMobile) {
      const imgIdMobile = extractImageId(imgMobile.src);
      if (variantImageIds.includes(imgIdMobile)) {
        // Remove the slide item itself
        slidesMobile.parentNode.remove();
      }
    }
  });




 const flickityContainer = document.querySelector('#Product-Thumbnails .product-thumbnail-container--inner');
  if (flickityContainer && typeof Flickity !== 'undefined') {
    const flkty = Flickity.data(flickityContainer); // Get existing Flickity instance
    if (flkty) {
      
      console.log('Reloading Flickity after mobile slide removal');
      flkty.reloadCells();
      flkty.resize();
      flkty.select(0);
    }
  }

});

function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function checkCondition() {
      if (conditionFn()) {
        resolve();
      } else {
        requestAnimationFrame(checkCondition);
      }
    }
    checkCondition();
  });
}
waitUntil(() => document.querySelector(".template-new-product .main_container_metafield .size_detail")).then(() => {

      const blocks = document.querySelectorAll('.main_container_metafield .size_detail');

      blocks.forEach((block, index) => {
        const header = block.querySelector('.detail');
        const content = block.querySelector('.metafield-rich_text_field');

        // Inject SVG icon once
        if (!header.querySelector('.cp-acc-icon')) {
          const icon = document.createElement('span');
          icon.className = "cp-acc-icon";
          icon.innerHTML = `
        <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 0.5L4 3.5L7 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      `;
          header.appendChild(icon);
        }

        // ✅ Close all by default
        if (index !== 0) content.style.display = "none";
        else block.classList.add("cp-active-accordion"); // first open

        header.addEventListener('click', () => {
          const isActive = block.classList.contains('cp-active-accordion');

          // Close all first
          blocks.forEach(b => {
            //b.classList.remove('cp-active-accordion');
            //b.querySelector('.metafield-rich_text_field').style.display = "none";
          });

          // Toggle selected
          if (!isActive) {
            block.classList.add('cp-active-accordion');
            content.style.display = "block";
          } else {
            block.classList.remove('cp-active-accordion');
            content.style.display = "none";
          }
        });
      });

    });


function waitForElement(selector, callback, timeout = 8000) {
  const start = Date.now();
  const check = () => {
    const el = document.querySelector(selector);
    if (el) return callback(el);

    if (Date.now() - start >= timeout) return;
    requestAnimationFrame(check);
  };
  check();
}


// waitForElement(".CP-video-section", () => {
// waitForElement("[id*=loox_reviews]", () => {

//   // SELECT ALL pill bars
//   const pillBars = document.querySelectorAll(".CP-pill");

//   pillBars.forEach((pillBar) => {
//     const pillDelivery  = pillBar.querySelector(".CP-delivery-pill");
//     const pillReview    = pillBar.querySelector(".CP-review-pill");
//     const pillDetail    = pillBar.querySelector(".CP-detail-pill");

//     const videoSection   = document.querySelector("#AddToCart");
//     const reviewSection  = document.querySelector("[id*=loox_reviews]");
//     const detailsSection = document.querySelector('[id*="image_text_pdp"] .main-contaner-image_text');

//     if (!pillDelivery || !pillReview || !pillDetail) {
//       return;
//     }

//     function setActive(pill) {
//       pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
//       pill.classList.add("CP-active");
//     }

// function scrollToVideoSection() {
//   const isMobile = window.innerWidth <= 768;

//   // MOBILE TARGET → #AddToCart
//   if (isMobile) {
//     const videoSection = document.querySelector("#AddToCart");
//     if (!videoSection) return;

//     let offset = 0;
//     if (document.body.classList.contains('template-product-new-product')) {
//       offset = -30;
//     } else if (document.body.classList.contains('template-product-hybrid')) {
//       offset = -17;
//     } else if (document.body.classList.contains('template-product-edc-product')) {
//       offset = -5;
//     } else if (document.body.classList.contains('template-product-new-product-burgundy-matte')) {
//       offset = -55;
//     }
//     const top = videoSection.getBoundingClientRect().top + window.scrollY - offset;

//     window.scrollTo({
//       top,
//       behavior: "smooth"
//     });

//     return; // stop here for mobile
//   }

//   // DESKTOP TARGET → .CP-video-section
//   const target = document.querySelector(".CP-video-section");
//   if (!target) return;

//   const activeBar = document.querySelector('.cstm_icon_with_content.icon_with_content_wrapper[style*="block"]');

//   let targetTop = target.getBoundingClientRect().top + window.scrollY;

//   if (activeBar) {
//     const activeHeight = activeBar.offsetHeight || 0;
//     targetTop -= (activeHeight + 160);
//   }

//   window.scrollTo({
//     top: targetTop,
//     behavior: "smooth"
//   });
// }

// // Call the function
// scrollToVideoSection();




//     // Reviews
//     function scrollToReviews() {
//       const offset = window.innerWidth <= 768 ? 90 : 61;
//       const top = reviewSection.getBoundingClientRect().top + window.scrollY - offset;
//       window.scrollTo({ top, behavior: "smooth" });
//     }

//     // Details
//     function scrollToDetails() {
//       const offset = window.innerWidth <= 768 ? 130 : 140;
//       const top = detailsSection.getBoundingClientRect().top + window.scrollY - offset;
//       window.scrollTo({ top, behavior: "smooth" });
//     }


//     // Attach Events
//     pillDelivery.addEventListener("click", () => {
//       setActive(pillDelivery);
//       scrollToVideoSection();
//     });

//     pillReview.addEventListener("click", () => {
//       setActive(pillReview);
//       scrollToReviews();
//     });

//     pillDetail.addEventListener("click", () => {
//       setActive(pillDetail);
//       scrollToDetails();
//     });
//   });

// });
// });

waitForElement(".CP-video-section", () => {
waitForElement("[id*=loox_reviews]", () => {

  // SELECT ALL pill bars
  const pillBars = document.querySelectorAll(".CP-pill");

  pillBars.forEach((pillBar) => {
    const pillDelivery  = pillBar.querySelector(".CP-delivery-pill");
    const pillReview    = pillBar.querySelector(".CP-review-pill");
    const pillDetail    = pillBar.querySelector(".CP-detail-pill");

    const videoSection   = document.querySelector("#AddToCart");
    const reviewSection  = document.querySelector("[id*=loox_reviews]");
    const detailsSection = document.querySelector('.product__accordion.accordion');

    if (!pillDelivery || !pillReview || !pillDetail) {
      return;
    }

    function setActive(pill) {
      pillBar.querySelectorAll("span").forEach(p => p.classList.remove("CP-active"));
      pill.classList.add("CP-active");
    }

function scrollToVideoSection() {
  const isMobile = window.innerWidth <= 768;

  // MOBILE TARGET → #AddToCart
  if (isMobile) {
    const videoSection = document.querySelector("#AddToCart");
    if (!videoSection) return;

    let offset = 0;
    if (document.body.classList.contains('template-product-new-product')) {
      offset = -30;
    } else if (document.body.classList.contains('template-product-hybrid')) {
      offset = -17;
    } else if (document.body.classList.contains('template-product-edc-product')) {
      offset = -5;
    } else if (document.body.classList.contains('template-product-new-product-burgundy-matte')) {
      offset = -55;
    }
    const top = videoSection.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top,
      behavior: "smooth"
    });

    return; // stop here for mobile
  }

  // DESKTOP TARGET → .CP-video-section
  const target = document.querySelector(".CP-video-section");
  if (!target) return;

  const activeBar = document.querySelector('.cstm_icon_with_content.icon_with_content_wrapper[style*="block"]');

  let targetTop = target.getBoundingClientRect().top + window.scrollY;

  if (activeBar) {
    const activeHeight = activeBar.offsetHeight || 0;
    targetTop -= (activeHeight + 160);
  }

  window.scrollTo({
    top: targetTop,
    behavior: "smooth"
  });
}

// Call the function
scrollToVideoSection();




    // Reviews
    function scrollToReviews() {
      const offset = window.innerWidth <= 768 ? 90 : 61;
      const top = reviewSection.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }

   function getDetailsTarget() {
      const ref = document.querySelector('.product-information--image.icons-contaienr.row');
      if (!ref) return null;
      return ref.nextElementSibling;
    }

    // Details
    function scrollToDetails() {
      const target = getDetailsTarget();
      if (!target) return;
      const top = target.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top, behavior: "smooth" });
    }


    // Attach Events
    pillDelivery.addEventListener("click", () => {
      setActive(pillDelivery);
      scrollToVideoSection();
    });

    pillReview.addEventListener("click", () => {
      setActive(pillReview);
      scrollToReviews();
    });

    pillDetail.addEventListener("click", () => {
      setActive(pillDetail);
      scrollToDetails();
    });
  });

});
});

document.addEventListener("DOMContentLoaded", initCPVideoSection);
document.addEventListener("shopify:section:load", initCPVideoSection);

function initCPVideoSection() {
  const wrappers = document.querySelectorAll(".CP-video-wrapper");

  if (!wrappers.length) {
    console.log("⛔ No video wrappers found");
    return;
  }

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector("video");
    const playBtn = wrapper.querySelector(".CP-play-btn");

    if (!video || !playBtn) {
      console.warn("⛔ Missing video or play button");
      return;
    }

    // Force mobile attributes
    video.setAttribute("playsinline", "");
    video.setAttribute("muted", "");
    video.setAttribute("preload", "metadata");

    // Icons
    const playIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#fff"><path d="m380-300 280-180-280-180v360Z"></path></svg>`;
    const pauseIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="#fff"><path d="M360-320h80v-320h-80v320Zm160 0h80v-320h-80v320Z"></path></svg>`;

    playBtn.addEventListener("click", (e) => {
      e.stopPropagation();

      if (video.paused) {
        video.play().then(() => {
          playBtn.innerHTML = pauseIcon;
        }).catch(err => console.log("Play error:", err));
      } else {
        video.pause();
        playBtn.innerHTML = playIcon;
      }
    });

    // Click wrapper to toggle
    wrapper.addEventListener("click", (e) => {
      if (e.target.closest(".CP-play-btn")) return;

      if (video.paused) {
        video.play().then(() => {
          playBtn.innerHTML = pauseIcon;
        });
      } else {
        video.pause();
        playBtn.innerHTML = playIcon;
      }
    });

    // Auto-pause on scroll out
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && !video.paused) {
          video.pause();
          playBtn.innerHTML = playIcon;
        }
      });
    }, { threshold: 0.25 });

    observer.observe(video);
  });

  console.log("🎉 CP video sections initialized successfully");
}


(function () {
  if (window.innerWidth >= 768) return; // mobile only

  function initVideoAutoplay() {
    const slider = document.querySelector('#Product-Slider');
    if (!slider) return false;

    const flkty = Flickity.data(slider);
    if (!flkty) return false;

    function pauseAllVideos() {
      slider.querySelectorAll('video').forEach(video => {
        video.pause();
      });
    }

    function playActiveVideo() {
      const slide = flkty.selectedElement;
      if (!slide) return;

      const video = slide.querySelector('video');
      if (!video) return;

      // iOS autoplay requirements
      video.muted = true;
      video.playsInline = true;

      try {
        video.currentTime = 0;
      } catch (e) {}

      // iOS Safari needs delayed play AFTER settle
      setTimeout(() => {
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      }, 250);
    }

    // Initial autoplay (very important for iOS)
    setTimeout(playActiveVideo, 500);

    // 🔑 Play video ONLY after Flickity finishes sliding
    flkty.on('settle', function () {
      pauseAllVideos();
      playActiveVideo();
    });

    return true;
  }

  // Wait until Flickity is actually initialized
  function waitForFlickity() {
    if (!initVideoAutoplay()) {
      setTimeout(waitForFlickity, 200);
    }
  }

  waitForFlickity();
})(); 
 


